import React, { useEffect, useState } from "react";
import PaginationFull from "../generic-ui/PaginationFull";
import Select from "../generic-ui/Select";
import { useDispatch, useSelector } from "react-redux";
import { startLoadingCatalogsAll } from "../../app/actions/catalogActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import L4CardAlternative from "./L4CardAlternative";
import { debugLogPages } from "../../app/helpers/debugHelper";
import IntegrationSearchChrome from "./IntegrationSearchChrome";

const listOptions = [3, 6, 9, 12, 15, 18, 21, 30, 60, 90, 100];

const L3ContainerAlternative = ({ data, totalPagesS, totalItemsS, currentPageS, onChangeSelect, onPageChange, itemsPerPage, moduleSelected }) => {
  
  debugLogPages(':: L3ContainerAlternative');

  const dispatch = useDispatch();

  //const { numberAlternativeSelected } = useSelector((state) => state.alternative);
  const { listFieldsAlternative } = useSelector((state) => state.moduleConfig);
  //const { comparisonAlternativeCheckEnabled } = useSelector((state) => state.configuration);
  const [, setListFieldsToCompare] = useState();


  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsAlternative.forEach(element => {
      if (element.is_comparable) {
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  useEffect(() => {
    dispatch(startLoadingCatalogsAll());
    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());
  }, [])

  const hasResults = data && data.length > 0;

  return (
    <div>
      <ul className="cards">
        {data && data.length > 0 && data.map((tec, index) => (
          <L4CardAlternative
            key={tec.id}
            data={tec}
            index={index}
            moduleSelected={moduleSelected}
          />
        ))}
      </ul>

      {data && data.length > 0 && (
        <div>
          <Select
            listOptions={listOptions}
            onChangeSelect={onChangeSelect}
            
            pageSize={itemsPerPage}
          />
        </div>
      )}

      <div className="pagination justify-content-center">
        {/*<Pagination
          totalPages={totalPagesS}
          totalItems={totalItemsS}
          currentPage={currentPageS + 1}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
      />*/}

        <PaginationFull
          totalRecords={totalItemsS}
          itemsPerPage={itemsPerPage}
          pageNeighbours={2}
          onPageChange={onPageChange}
          currentPage={currentPageS + 1}
          totalPages={totalPagesS}
        />
      </div>

      <hr />
      <br />

      <IntegrationSearchChrome
        hasResults={hasResults}
        moduleSelected={moduleSelected}
      />

    </div>
  );
};

export default L3ContainerAlternative;
